import { array, boolean, enums, object, string } from "superstruct";

import { REWARDS_CUSTOMER_ELIGIBILITY_TYPES } from "../../../constants/rewardsCustomerEligibilityTypes";

const RewardsStorefrontValuesCustomersEligibilitySettingsSchema = object({
    type: enums([
        REWARDS_CUSTOMER_ELIGIBILITY_TYPES.include,
        REWARDS_CUSTOMER_ELIGIBILITY_TYPES.exclude,
    ]),
    tags: array(string()),
    isEnabled: boolean(),
    showWidgetsToGuests: boolean(),
});

export default RewardsStorefrontValuesCustomersEligibilitySettingsSchema;
